<template>
  <div id="container">
    <h1>Welcome to Barqulator</h1>
    <!-- <router-link to="/admin" tag="button">admin</router-link> -->
  </div>
</template>

<script>
export default {
  name: "Start",
  data() {
    return {};
  },
  created() {},
};
</script>

<style scoped>
h1 {
  margin-top: 10%;
  font-size: 8em;
  color: white;
}

#container {
  position: absolute;
  text-align: center;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
  background: var(--barq-orange);
}

button {
  border: 2px solid white;
  background: none;
  color: white;
}
</style>
